import cn from 'classnames';
import React from 'react';
import { Skeleton } from '../Skeleton';
import styles from './rwstep.module.sass';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    activeIndex?: number; // Optional when loading
    rewardBadges?: string[];
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    activeIndex: number; // Required when not loading
    rewardBadges?: string[];
}

type RewardStepProps = LoadingProps | LoadedProps;

export const RewardStep = ({ activeIndex = 1, isLoading, rewardBadges = [], ...props }: RewardStepProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.rwstep, styles.loading, props.className)}>
                <Skeleton height={48} />
            </div>
        );
    }

    return (
        <div {...props} className={cn(styles.rwstep, props.className)}>
            {rewardBadges.map((step, index) => {
                return (
                    <div className={cn(styles.step, index === activeIndex && styles.current)} key={`rw-step-${index}`}>
                        <img src={step} alt={`step-${index}`} data-test-id={`reward-step-${index}-img`} />
                    </div>
                );
            })}
        </div>
    );
};
